const BANNER_KEY_PREFIX = 'bannerstopautoplay';

export function getBannerStopAutoplayEventKey(bannerGroupId: string) {
  return `${BANNER_KEY_PREFIX}_${bannerGroupId}`;
}
